import * as z from "zod"
import { FieldApplyOutcome } from "@prisma/client"

export const DraftFieldApplicationModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  draft_id: z.number().int(),
  entity: z.string(),
  entity_id: z.number().int(),
  field: z.string(),
  outcome: z.nativeEnum(FieldApplyOutcome),
  old_value: z.string().nullish(),
  new_value: z.string().nullish(),
  applied_by_id: z.number().int().nullish(),
  ingest_execution_id: z.number().int().nullish(),
})
